import * as React from "react";
import { useState } from 'react';
import RcsChatLogTable from './RcsChatLogTable';
import {
  Box,
  Grid,
  Typography
} from '@mui/material';
import typography from "../../cssUtils/typography";

const RcsChatLog = (props) => { 
  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: 20,
    serverSidePage: 0
  });
  const [lastSynced, setLastSynced] = useState(null);

  return (
    <div className="App">
      <Box sx={{ px: 0, width: "100%"}}>
        <Grid container alignItems="center" sx={{ mb: 2 }}>
          <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', mr:0 }}>
            {lastSynced && (
              <Typography 
                sx={{ ...typography.bodyLarge}}
                color="text.secondary"
              >
                Last chat received: {lastSynced} <i>(Logs may take up to 2 minutes to sync)</i>
              </Typography>
            )}
          </Grid>
        </Grid>

        <RcsChatLogTable 
          key={props.refreshKey} 
          controller={controller}
          setController={setController}
          lastSynced={lastSynced}
          setLastSynced={setLastSynced}
        />
      </Box>
    </div>
  );
}
export default RcsChatLog;